var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-send-reply 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 12C10.3018 9.75182 9.63815 8.81818 7 8.81818H5.61538V11.5455L1 6.54545L5.61538 2V4.72727H6.53846C11.1538 4.72727 12.0769 9.27273 13 12Z",
    stroke: "#FF8503",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyIcon);
export default __webpack_public_path__ + "static/media/replyIcon.890dafd893bf97f54466ca22528e680f.svg";
export { ForwardRef as ReactComponent };